import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const LessonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
  padding: 0 1rem;
`;

export const LessonImage = styled.div`
  width: 25%;
  height: 6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  background: ${colors.GRAY};
  position: relative;
`;

export const isActiveStyle = {
  background: colors.GREEN_LIGHT_TRANSPARENT,
  padding: '1rem 1rem',
  borderRadius: '1rem 0 0 1rem',
};

export const noImageIcon = {
  fontSize: '1.5rem',
  color: colors.GRAY_DARK,
};

export const lessonTitle = {
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
};

export const thumbnailImage = {
  maxWidth: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '1rem',
};

export default {
  LessonContainer,
  LessonImage,
  isActiveStyle,
  noImageIcon,
  lessonTitle,
  thumbnailImage,
};
